import React, { FC } from "react";
import { withProcedureWraper } from "../..";
import { Box } from "../../../../components/box";
import { Container, Row, Button, Col } from "react-bootstrap";
import FontFa from "../../../../components/fontFa/fontFa";

export const SettingDocumentPermissionPage: FC = withProcedureWraper(() => {
  return (
    <div className="ProcedureTrainingPlanPage">
      <div className="pd15">
        <div className="d-flex p-3 justify-content-center">
          <h3>
            <br />
          </h3>
        </div>
        <Box title={"Phân quyền"}>
          <Container>
            <Row>
              <Col xs={12} sm={12} md={{ span: 10, offset: 1 }}>
                <div className="document-detail__info py-5 px-5">
                  <div className="info-body">
                    <div className="TimelineBox">
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Khởi tạo"}</div>
                          <div className="des">dòng 2</div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Đang soạn thảo"}</div>
                          <div className="des">dòng 3</div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Lấy ý kiến"}</div>
                          <div className="des">Dòng 4</div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Soát xét"}</div>
                          <div className="des">Dòng 5</div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Ban hành tạm thời"}</div>
                          <div className="des"></div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Phê duyệt"}</div>
                          <div className="des">dòng 6</div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Sẵn sàng để ban hành"}</div>
                          <div className="des">Dòng 7</div>
                          {
                            <>
                              <div className="text-right mt-3">
                                <Button size={"sm"} variant="outline-info">
                                  {"Cài đặt"}
                                </Button>
                              </div>
                            </>
                          }
                        </div>
                      </div>
                      <div className="item">
                        <div className={`step approved`}>
                          <FontFa name="faCheck" />
                        </div>
                        <div className="content">
                          <div className="title">{"Ban hành"}</div>
                        </div>
                        {/* ban hành cuối cùng nối div ở đây */}
                        <div className="text-right mt-3">
                          <Button className="mr-2" variant="danger">
                            {"Hủy"}
                          </Button>
                          {
                            <Button className="ml-2" variant="info">
                              {"Lưu"}
                            </Button>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </Box>
      </div>
    </div>
  );
});
